<template>
  <v-card
    :flat="card.flat || true"
    :shaped="card.shaped || false"
    :rounded="card.rounded || true"
    :tile="card.tile || false"
    :class="card.class || 'ma-1 pa-3'"
    :elevation="typeof card.elevation == 'undefined' ? '0' : card.elevation"
    :ripple="card.ripple || false"
    :color="card.color || 'transparent'"
    max-width="320"
    hover
    :href="link"
    @click="!link ? $emit('openInspect', product.id) : null" 
  >
    <v-card-text
      class="title d-flex flex-row"
    > 
      <pictures
        class="rounded"
        :images="product.images"
        :options="(options||{}).carousel"
        :small="small"
      />
      <div>
        <div
          class="mx-2 d-flex flex-column subtitle-1 text-uppercase font-weight-bold"
        >
          {{ product.name }}
        </div>
        <div
          class="mx-2 d-flex flex-column text-caption"
          style="line-height: normal;"
        >
          {{ product.description }}
        </div>
      </div>

      <v-sheet
        v-if="product.properties && product.properties.price"
        :color="card.color || 'transparent'"
      >
        $ {{ product.properties.price }}
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
import Pictures from '../PicturesSmall.vue'

export default {
  name: 'ProductCardSmall',
  components: {Pictures},
  props: {
    card: {
      type: Object,
      default: ()=>{return {}}
    },
    product: {
      type: Object,
      default: ()=>{return {}}
    },
    small: {
      type: Boolean
    },
    options: {
      type: Object,
      default: ()=>{return {}}
    },
  },
  computed: {
    link() {
      return this.product.properties && this.product.properties.external_link
    }
  },
}
</script>

<style>

</style>